import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import React, { useEffect } from 'react';

import { IMainLayoutDomainStore } from '../../main/store/domain/IMainLayoutDomainStore';
import { ILayoutNotification, LayoutNotificationType } from './store/ILayoutNotification';

export interface NotificationWrapperProperties {
  children: any;
}

export const useStyles = makeStyles((theme: Theme) => ({
  info: {
    backgroundColor: alpha(theme.palette.info.main, 0.75) + ' !important',
    color: `${theme.palette.text.primary} !important`,
    fontSize: '16px !important',
  },
  warning: {
    backgroundColor: alpha(theme.palette.warning.main, 0.75) + ' !important',
    color: `${theme.palette.text.primary} !important`,
    fontSize: '16px !important',
  },
  error: {
    backgroundColor: alpha(theme.palette.error.main, 0.75) + ' !important',
    color: `${theme.palette.text.primary} !important`,
    fontSize: '16px !important',
    maxWidth: '40%',
    maxHeight: '250px',
    height: '100%',
  },
  success: {
    backgroundColor: alpha(theme.palette.success.main, 0.75) + ' !important',
    color: `${theme.palette.text.primary} !important`,
    fontSize: '16px !important',
  },
}));

export const NotificationWrapper = ({ children }: NotificationWrapperProperties) => {
  const classes = useStyles();

  return (
    <SnackbarProvider
      classes={{
        variantInfo: classes.info,
        variantWarning: classes.warning,
        variantError: classes.error,
        variantSuccess: classes.success,
      }}
      maxSnack={3}
    >
      {children}
    </SnackbarProvider>
  );
};

export interface NotificationHandlerProperties {
  layoutDomain: IMainLayoutDomainStore;
}

export const NotificationHandler = observer(({ layoutDomain }: NotificationHandlerProperties) => {
  const { enqueueSnackbar } = useSnackbar();
  const newNotifications = layoutDomain.notifications.getNewNotifications();

  useEffect(() => {
    const notificationTypeToSnackbarTypeMap: any = {
      [LayoutNotificationType.text]: 'info',
      [LayoutNotificationType.info]: 'info',
      [LayoutNotificationType.warning]: 'warning',
      [LayoutNotificationType.error]: 'error',
      [LayoutNotificationType.success]: 'success',
    };
    newNotifications.forEach((notification: ILayoutNotification) => {
      const snackbarType = notificationTypeToSnackbarTypeMap[notification.type] || 'default';
      enqueueSnackbar(notification.text, {
        variant: snackbarType,
      });
      layoutDomain.notifications.markNotificationAsCompleted(notification.id || '');
    });
  }, [layoutDomain, newNotifications, enqueueSnackbar]);

  return <div />;
});
